import 'spectre.css/dist/spectre.min.css';
import './styles/app.css'
import './styles/common.css'

import { createApp } from 'vue';
import App from './App.vue'

const app = createApp(App);
app.mount("#app");

